"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getFieldIDByIndex = function getFieldIDByIndex(field, sectionID, fieldID) {
  // If SectionID does not contain array index [] then it is just a regular field
  if (sectionID.indexOf('[]') === -1) {
    return "".concat(sectionID, "__").concat(fieldID);
  } // SectionID has array index [] - first extract array index
  // Find the index of array using field.id field
  // Index is between `-`


  var matches = field.id.match(/-(\d*)-/);
  var index = matches.length > 1 ? matches[1] : 0;
  return "".concat(sectionID.replace('[]', ''), "[").concat(index, "].").concat(fieldID);
};
/**
 * Check if a field value is not greater than another field value, if no specific field is passed it will return true.
 * If compare field is part of an array then use [] in the sectionID
 * @param message
 * @param sectionID
 * @param fieldID
 * @returns {function({field: *})}
 */
//TODO: THIS NEEDS TO BE REMOVED AND IT'S SINGLE USE REVISED


var careDateIsNotGreater = function careDateIsNotGreater(message, sectionID, fieldID, options) {
  return function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    var enteredValue = field.value;

    if (fieldID && sectionID) {
      try {
        // Get the compareValue using the sectionID, index, fieldID
        var compareValue = form.$(getFieldIDByIndex(field, sectionID, fieldID)).value;
        var isEmptyAllowed = options && options.skipCompareIfOneFieldIsEmpty && (compareValue === '' || enteredValue === '');

        if (isEmptyAllowed) {
          return [true, message || 'Please enter an earlier date'];
        }

        if (compareValue > enteredValue) {
          return [false, message || "Please enter a date before ".concat(compareValue)];
        }
      } catch (err) {
        console.log(err);
      }
    }

    return [true, message || 'Please enter an earlier date'];
  };
};

var _default = careDateIsNotGreater;
exports.default = _default;
//# sourceMappingURL=careDateIsNotGreater.js.map